<template>
  <Loader v-if="loading" />
  <div>
    <!-- Upload Section -->
    <div class="center-content">
      <Card class="upload-card">
        <template #content>
          <h1 class="page-title">Sospensioni E Riattivazioni</h1>

          <!-- Upload Cards (Solo per i flussi che richiedono caricamento manuale) -->
          <div class="card-group">
            
            <!-- 1. Esito Card -->
            <Card class="upload-cards">
              <template #content>
                <div class="file-upload-container">
                  <h3>Esito</h3>
                  <div class="upload-area">
                    <div class="upload-zone">
                      <div class="button-wrapper">
                        <span class="label">{{
                          esitoFiles.length === 0 ? "Seleziona File" : `${esitoFiles.length} file selezionati`
                        }}</span>
                        <input id="upload-esito" type="file" ref="esitoFileInput" multiple
                          @change="(evt) => handleSpecificFileUpload(evt, 'Esito')" accept=".csv" />
                      </div>
                      <div v-show="esitoValidationError && esitoSubmitted" class="p-error">Campo richiesto.</div>
                      <div class="text-center mt-3"><small>Formati consentiti: {{ allowedType.join(", ") }}</small></div>
                    </div>
                    <div v-if="esitoFiles.length > 0" class="files-preview">
                      <div v-for="(file, index) in esitoFiles" :key="`esito-${index}`" class="file-preview">
                        <div class="file-name-container"><i class="pi pi-file-excel"></i><span class="file-name">{{ file.name }}</span></div>
                        <span class="file-size">{{ formatFileSize(file.size) }}</span>
                        <button @click="removeFile('Esito', index)" class="remove-file-button"><i class="pi pi-times"></i></button>
                      </div>
                      <Button v-if="esitoFiles.length > 0" @click="uploadSpecificFiles('Esito')" class="upload-button">
                        <span>Carica file ({{ esitoFiles.length }})</span><i class="pi pi-upload"></i>
                      </Button>
                    </div>
                  </div>
                  <div v-if="lastUploadedFiles.Esito" class="last-uploaded-file">
                    <div class="last-file-header"><i class="pi pi-check-circle"></i><span>Ultimo file caricato:</span></div>
                    <div class="last-file-content">
                      <div class="last-file-name">{{ lastUploadedFiles.Esito.file_name }}</div>
                      <div class="last-file-date">{{ formatDate(lastUploadedFiles.Esito.created_at) }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </Card>

            <!-- 2. Risposte Card -->
            <Card class="upload-cards">
              <template #content>
                <div class="file-upload-container">
                  <h3>Risposte</h3>
                  <div class="upload-area">
                    <div class="upload-zone">
                      <div class="button-wrapper">
                        <span class="label">{{
                          risposteFiles.length === 0 ? "Seleziona File" : `${risposteFiles.length} file selezionati`
                        }}</span>
                        <input id="upload-risposte" type="file" ref="risposteFileInput" multiple
                          @change="(evt) => handleSpecificFileUpload(evt, 'Risposte')" accept=".csv" />
                      </div>
                      <div v-show="risposteValidationError && risposteSubmitted" class="p-error">Campo richiesto.</div>
                      <div class="text-center mt-3"><small>Formati consentiti: {{ allowedType.join(", ") }}</small></div>
                    </div>
                    <div v-if="risposteFiles.length > 0" class="files-preview">
                      <div v-for="(file, index) in risposteFiles" :key="`risposte-${index}`" class="file-preview">
                        <div class="file-name-container"><i class="pi pi-file-excel"></i><span class="file-name">{{ file.name }}</span></div>
                        <span class="file-size">{{ formatFileSize(file.size) }}</span>
                        <button @click="removeFile('Risposte', index)" class="remove-file-button"><i class="pi pi-times"></i></button>
                      </div>
                      <Button v-if="risposteFiles.length > 0" @click="uploadSpecificFiles('Risposte')" class="upload-button">
                        <span>Carica file ({{ risposteFiles.length }})</span><i class="pi pi-upload"></i>
                      </Button>
                    </div>
                  </div>
                  <div v-if="lastUploadedFiles.Risposte" class="last-uploaded-file">
                    <div class="last-file-header"><i class="pi pi-check-circle"></i><span>Ultimo file caricato:</span></div>
                    <div class="last-file-content">
                      <div class="last-file-name">{{ lastUploadedFiles.Risposte.file_name }}</div>
                      <div class="last-file-date">{{ formatDate(lastUploadedFiles.Risposte.created_at) }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </Card>

            <!-- 3. Tracking Card -->
            <Card class="upload-cards">
              <template #content>
                <div class="file-upload-container">
                  <h3>Tracking</h3>
                  <div class="upload-area">
                    <div class="upload-zone">
                      <div class="button-wrapper">
                        <span class="label">{{
                          trackingFiles.length === 0 ? "Seleziona File" : `${trackingFiles.length} file selezionati`
                        }}</span>
                        <input id="upload-tracking" type="file" ref="trackingFileInput" multiple
                          @change="(evt) => handleSpecificFileUpload(evt, 'Tracking')" accept=".csv" />
                      </div>
                      <div v-show="trackingValidationError && trackingSubmitted" class="p-error">Campo richiesto.</div>
                      <div class="text-center mt-3"><small>Formati consentiti: {{ allowedType.join(", ") }}</small></div>
                    </div>
                    <div v-if="trackingFiles.length > 0" class="files-preview">
                      <div v-for="(file, index) in trackingFiles" :key="`tracking-${index}`" class="file-preview">
                        <div class="file-name-container"><i class="pi pi-file-excel"></i><span class="file-name">{{ file.name }}</span></div>
                        <span class="file-size">{{ formatFileSize(file.size) }}</span>
                        <button @click="removeFile('Tracking', index)" class="remove-file-button"><i class="pi pi-times"></i></button>
                      </div>
                      <Button v-if="trackingFiles.length > 0" @click="uploadSpecificFiles('Tracking')" class="upload-button">
                        <span>Carica file ({{ trackingFiles.length }})</span><i class="pi pi-upload"></i>
                      </Button>
                    </div>
                  </div>
                  <div v-if="lastUploadedFiles.Tracking" class="last-uploaded-file">
                    <div class="last-file-header"><i class="pi pi-check-circle"></i><span>Ultimo file caricato:</span></div>
                    <div class="last-file-content">
                      <div class="last-file-name">{{ lastUploadedFiles.Tracking.file_name }}</div>
                      <div class="last-file-date">{{ formatDate(lastUploadedFiles.Tracking.created_at) }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </Card>

          </div>

          <!-- Sync Button -->
          <div class="sync-container">
            <Button @click="syncAndClearFiles" class="p-button-secondary sync-button">
              <i class="pi pi-sync"></i>
              <span>Aggiorna stati</span>
            </Button>
          </div>
        </template>
      </Card>
    </div>

    <!-- History Section -->
    <div class="center-content">
      <Card class="history-card">
        <template #header>
          <h3 class="page-title">Storico File Caricati</h3>
          <div class="filter-buttons-SwitchOut">
            <!-- Qui includiamo TUTTI i filtri, anche per quelli caricati solo da PDC -->
            <SelectButton v-model="selectedFilter" :options="filterOptions" @update:modelValue="handleFilterChange"
              aria-labelledby="filter-type" :allowEmpty="false" optionLabel="name" optionValue="code" />
          </div>
        </template>
        <template #content>
          <div class="search-container">
            <input type="text" v-model="searchQuery" placeholder="Cerca file..." class="file-search-input" />
          </div>
          <table class="file-table">
            <thead>
              <tr>
                <th>File</th>
                <th>Data di caricamento</th>
                <th>Tipologia</th>
                <th>Utente</th>
                <th>Scarica</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="file in filteredFiles" :key="file.file_name">
                <td>{{ file.file_name || "Sconosciuto" }}</td>
                <td>{{ formatDate(file.created_at) || "N/A" }}</td>
                <td>{{ file.name_fornitore || "N/A" }}</td>
                <td><span class="email">{{ file.email || "N/A" }}</span></td>
                <td>
                  <button @click="handleFileDownload(file.file_name, file.name_fornitore)" class="download-button">
                    <i class="pi pi-download"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="filteredFiles.length === 0">
                <td colspan="5">Nessun file trovato</td>
              </tr>
            </tbody>
          </table>
          <div class="file-count-select-wrapper">
            <select id="fileCount" v-model="filesPerPage" class="file-count-select">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted } from "vue";
import { useStore } from "vuex";
import Service from "@/services/ask-caricamento-file/caricamento-file";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import SelectButton from "primevue/selectbutton";

export default {
  components: {
    Loader,
    SelectButton
  },

  setup() {
    const store = useStore();
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);
    
    // File Inputs Refs (Solo per quelli manuali)
    const esitoFileInput = ref(null);
    const risposteFileInput = ref(null);
    const trackingFileInput = ref(null);

    // File Lists
    const esitoFiles = ref([]);
    const risposteFiles = ref([]);
    const trackingFiles = ref([]);

    const currentUser = ref(store.state.auth.user);
    const allowedType = ["csv"];
    const validationErrors = ref({});
    const submitted = ref(false);
    const loading = ref(false);
    const uploadedFiles = ref([]);
    const currentPage = ref(1);
    const filesPerPage = ref(10);
    const searchQuery = ref("");
    const subdirectories = ref([]);
    const selectedSubdirectory = ref("Seleziona una Cartella");
    const originalUploadedFiles = ref([]);
    const logMessages = ref([]);
    
    // Filtri per la tabella (Qui includiamo anche i nuovi flussi)
    const selectedFilter = ref('Esito');
    const filterOptions = ref([
      { name: "Esito", code: "Esito" },
      { name: "Risposte", code: "Risposte" },
      { name: "Tracking", code: "Tracking" },
      { name: "RT1.0200", code: "Riattivati" }, // Visibile solo in storico
      { name: "SM3 - RT3", code: "NotificheCC" } // Visibile solo in storico
    ]);

    // Ultimi file caricati (Mantieniamo la struttura per aggiornare le card esistenti)
    const lastUploadedFiles = ref({ 
      Esito: null, 
      Risposte: null, 
      Tracking: null,
      Riattivati: null, 
      NotificheCC: null 
    });
    
    // Validazione e Submit (Solo per manuali)
    const esitoValidationError = ref(false);
    const risposteValidationError = ref(false);
    const trackingValidationError = ref(false);

    const esitoSubmitted = ref(false);
    const risposteSubmitted = ref(false);
    const trackingSubmitted = ref(false);

    // Rimuovi un file dalla lista
    const removeFile = (fileType, index) => {
      switch (fileType) {
        case 'Esito':
          esitoFiles.value.splice(index, 1);
          break;
        case 'Risposte':
          risposteFiles.value.splice(index, 1);
          break;
        case 'Tracking':
          trackingFiles.value.splice(index, 1);
          break;
      }
    };

    const handleSpecificFileUpload = (evt, fileType) => {
      evt.preventDefault();

      const files = Array.from(evt.target.files || []);
      if (files.length === 0) return;

      const maxSize = 500000 * 1024;
      const validFiles = [];
      
      files.forEach(file => {
        if (file.size > maxSize) {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: `Il file ${file.name} supera la dimensione massima consentita (500 MB)`,
          });
          return;
        }

        const extension = file.name.split('.').pop().toLowerCase();
        if (!allowedType.includes(extension)) {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: `Il file ${file.name} ha un formato non consentito. Formati consentiti: ${allowedType.join(', ')}`,
          });
          return;
        }

        validFiles.push(file);
      });

      switch (fileType) {
        case 'Esito':
          esitoFiles.value = [...esitoFiles.value, ...validFiles];
          break;
        case 'Risposte':
          risposteFiles.value = [...risposteFiles.value, ...validFiles];
          break;
        case 'Tracking':
          trackingFiles.value = [...trackingFiles.value, ...validFiles];
          break;
      }
    };

    const uploadSpecificFiles = async (fileType) => {
      let filesToUpload;

      switch (fileType) {
        case 'Esito':
          filesToUpload = esitoFiles.value;
          esitoSubmitted.value = true;
          if (filesToUpload.length === 0) { esitoValidationError.value = true; return; }
          break;
        case 'Risposte':
          filesToUpload = risposteFiles.value;
          risposteSubmitted.value = true;
          if (filesToUpload.length === 0) { risposteValidationError.value = true; return; }
          break;
        case 'Tracking':
          filesToUpload = trackingFiles.value;
          trackingSubmitted.value = true;
          if (filesToUpload.length === 0) { trackingValidationError.value = true; return; }
          break;
        default:
          return;
      }
      
      if (filesToUpload.length === 0) {
        toast.add({ severity: "error", summary: "Errore", detail: "Nessun file selezionato da caricare" });
        return;
      }

      loading.value = true;

      try {
        let response = null;

        switch (fileType) {
          case 'Esito':
            response = await service.importEsitoSospensioniRiattivazioniToDatabase(filesToUpload, fileType);
            break;
          case 'Risposte':
            response = await service.importRisposteSospensioniRiattivazioniToDatabase(filesToUpload, fileType);
            break;
          case 'Tracking':
            response = await service.importTrackingSospensioniRiattivazioniToDatabase(filesToUpload, fileType);
            break;
        }

        if (response) {
          clearLastUploadedFiles();
          fetchUploadedFiles();
        }

        const uploaded = response.files.map((file) => ({
          ...file,
          created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          name_fornitore: fileType,
          email: currentUser.value.email,
        }));

        uploadedFiles.value = [...uploadedFiles.value, ...uploaded];
        originalUploadedFiles.value = [...originalUploadedFiles.value, ...uploaded];

        if (uploaded.length > 0) {
          lastUploadedFiles.value[fileType] = uploaded[uploaded.length - 1];
        }

        // Reset file inputs e state
        switch (fileType) {
          case 'Esito':
            esitoFiles.value = [];
            if (esitoFileInput.value) esitoFileInput.value.value = "";
            esitoValidationError.value = false; esitoSubmitted.value = false;
            break;
          case 'Risposte':
            risposteFiles.value = [];
            if (risposteFileInput.value) risposteFileInput.value.value = "";
            risposteValidationError.value = false; risposteSubmitted.value = false;
            break;
          case 'Tracking':
            trackingFiles.value = [];
            if (trackingFileInput.value) trackingFileInput.value.value = "";
            trackingValidationError.value = false; trackingSubmitted.value = false;
            break;
        }

        const message = response.message || "File Caricati con successo";
        toast.add({ severity: "success", summary: "Successo", detail: message, life: 5000 });
      } catch (error) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: (error.response && error.response.data && error.response.data.message) || "Si è verificato un errore durante il caricamento dei file",
        });
      } finally {
        loading.value = false;
      }
    };

    const formatFileSize = (bytes) => {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const updateFiles = async () => {
      loading.value = true;
      try {
        const result = await service.aggiornaStatiSospensioniRiattivazioni();
        if (result) {
          toast.add({ severity: "success", summary: "Successo", detail: "Stati aggiornati", life: 3000 });
          clearLastUploadedFiles();
        }
      } catch (error) {
        toast.add({ severity: "error", summary: "Errore", detail: error, life: 3000 });
      } finally {
        loading.value = false;
      }
    };

    const syncAndClearFiles = () => {
      updateFiles();
    };

    const clearLastUploadedFiles = () => {
      lastUploadedFiles.value = { Esito: null, Risposte: null, Tracking: null, Riattivati: null, NotificheCC: null };
    };

    const fetchUploadedFiles = async () => {
      try {
        const filesResponse = await service.getAllUploadedFilesSospensioniERiattivazioni();
        const formattedFiles = filesResponse.map((file) => {
          return {
            ...file,
            created_at: moment(file.created_at).format("YYYY-MM-DD HH:mm:ss"),
          };
        });
        uploadedFiles.value = formattedFiles;
        originalUploadedFiles.value = formattedFiles;
        updateLastUploadedFiles();
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        toast.add({ severity: "error", summary: "Errore", detail: "Errore durante il recupero dei file" });
      }
    };

    const updateLastUploadedFiles = () => {
      const latestFiles = { Esito: null, Risposte: null, Tracking: null, Riattivati: null, NotificheCC: null };
      originalUploadedFiles.value.forEach((file) => {
        // CORREZIONE ESLINT: Uso di Object.prototype.hasOwnProperty.call
        if (Object.prototype.hasOwnProperty.call(latestFiles, file.name_fornitore)) {
           if (!latestFiles[file.name_fornitore] || moment(file.created_at).isAfter(latestFiles[file.name_fornitore].created_at)) {
             latestFiles[file.name_fornitore] = file;
           }
        }
      });
      lastUploadedFiles.value = latestFiles;
    };

    const getSubDirectorySospensioniERiattivazioni = async () => {
      loading.value = true;
      try {
        const response = await service.getSubDirectorySospensioniERiattivazioni();
        if (response && Array.isArray(response)) {
          subdirectories.value = response.map((item) => {
            const parts = item.value.split("/");
            return parts[parts.length - 1];
          });
        }
      } catch (error) {
        console.error("Errore durante il recupero dell'elenco delle sottodirectory:", error);
      } finally {
        loading.value = false;
      }
    };

    const fetchUploadedFilesFromDatabase = async () => {
      try {
        const filesResponse = await service.getSubDirectorySospensioniERiattivazioni();
        uploadedFiles.value = filesResponse;
      } catch (error) {
        console.error("Errore durante il recupero dei file dal database:", error);
        toast.add({ severity: "error", summary: "Errore", detail: "Errore durante il recupero dei file dal database" });
      }
    };

    const fetchSubdirectoriesNomi = async () => {
      try {
        subdirectories.value = await service.getSubDirectorySospensioniERiattivazioniNomi();
      } catch (error) {
        console.error("Errore durante il recupero dei nomi delle sottodirectory:", error);
        toast.add({ severity: "error", summary: "Errore", detail: "Errore durante il recupero dei nomi delle sottodirectory" });
      }
    };

    onMounted(async () => {
      try {
        await fetchUploadedFilesFromDatabase();
        await fetchSubdirectoriesNomi();
        await fetchUploadedFiles();
      } catch (error) {
        console.error("Errore durante il caricamento iniziale:", error);
        toast.add({ severity: "error", summary: "Errore", detail: "Errore durante il caricamento iniziale" });
      }
    });

    const formatDate = (date) => {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    };

    const paginatedFiles = computed(() => {
      const startIndex = (currentPage.value - 1) * filesPerPage.value;
      const endIndex = startIndex + filesPerPage.value;
      return filteredFiles.value.slice(startIndex, endIndex);
    });

    const filteredFiles = computed(() => {
      if (!uploadedFiles.value || uploadedFiles.value.length === 0) {
        return [];
      }

      return uploadedFiles.value
        .filter((file) => {
          return file.name_fornitore === selectedFilter.value;
        })
        .filter((file) => {
          if (!searchQuery.value) return true;
          const search = searchQuery.value.toLowerCase();
          return (
            (file.file_name && file.file_name.toLowerCase().includes(search)) ||
            (file.email && file.email.toLowerCase().includes(search))
          );
        });
    });

    const handleFilterChange = (newFilterValue) => {
      selectedFilter.value = newFilterValue;
    };

    const handleFileDownload = async (filename, subdirectory) => {
      try {
        const response = await service.downloadFileSospensioniERiattivazioni(filename, subdirectory);
        const blob = new Blob([response.data], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        let cleanFilename = filename.split('/').pop();
        if (!cleanFilename.endsWith('.csv')) {
          cleanFilename += '.csv';
        }
        link.setAttribute("download", cleanFilename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Errore durante il download:", error);
        let errorMessage = "Errore durante il download del file";
        if (error.response && error.response.status === 404) {
          errorMessage = "File non trovato";
        } else if (error.response && error.response.status === 500) {
          errorMessage = "Errore interno del server";
        }
        toast.add({ severity: "error", summary: "Errore", detail: errorMessage, life: 3000 });
      }
    };

    return {
      // Refs
      esitoFileInput, risposteFileInput, trackingFileInput,
      // Files Lists
      esitoFiles, risposteFiles, trackingFiles,
      // Validation & Submitted
      esitoValidationError, risposteValidationError, trackingValidationError,
      esitoSubmitted, risposteSubmitted, trackingSubmitted,
      // Methods
      handleSpecificFileUpload,
      uploadSpecificFiles,
      removeFile,
      formatFileSize,
      fetchUploadedFiles,
      updateFiles,
      syncAndClearFiles,
      handleFileDownload,
      handleFilterChange,
      formatDate,
      // Data
      store,
      validationErrors,
      submitted,
      service,
      moment,
      allowedType,
      uploadedFiles,
      loading,
      logMessages,
      currentUser,
      currentPage,
      filesPerPage,
      paginatedFiles,
      searchQuery,
      filteredFiles,
      subdirectories,
      selectedSubdirectory,
      lastUploadedFiles,
      filterOptions,
      selectedFilter
    };
  },
};
</script>

<style scoped>
:root {
  --primary-color: #3B82F6;
  --success-color: #4CAF50;
  --border-color: #e2e8f0;
  --text-primary: #0f172a;
  --text-secondary: #475569;
  --bg-gradient: linear-gradient(0deg, #04ba2e 70%, #cad806 100%);
  --accent-green: #1f5d38;
  --card-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  --danger-color: #dc3545;
}

.center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 2000px;
  margin: 0 auto;
  padding: 2rem;
}

.page-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: var(--text-primary);
  text-align: center;
  margin: 1.5rem 0;
}

/* Modificato per gestire il wrap automatico */
.card-group {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Torna a 3 colonne fisse per le card legacy */
  gap: 2rem;
  width: 100%;
  margin: 2rem 0;
}

.upload-cards {
  background: white;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  border: none;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

.upload-cards:hover {
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
}

.upload-card,
.history-card {
  background: white;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  width: 100%;
  overflow: hidden;
  border: none;
}

.file-upload-container {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  width: 100%;
}

.file-upload-container h3 {
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--accent-green);
  margin-bottom: 1.5rem;
  text-align: center;
}

.upload-area {
  width: 100%;
}

.upload-zone {
  width: 100%;
  border: 2px dashed #e2e8f0;
  border-radius: 10px;
  padding: 1.5rem;
  text-align: center;
  background-color: #f8fafc;
  margin-bottom: 1rem;
}

.button-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #f2f2f2 !important;
  cursor: pointer;
  padding: 12px 0;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

#upload-esito,
#upload-risposte,
#upload-tracking {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.files-preview {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
  max-height: 300px;
  overflow-y: auto;
  padding-right: 8px;
}

.files-preview .file-preview {
  background: #f8fafc;
  border-radius: 8px;
  padding: 12px;
  margin-top: 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  overflow: hidden;
  word-break: normal;
  margin-bottom: 0;
}

.files-preview .file-name-container {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  flex: 1;
}

.files-preview .file-name-container i {
  font-size: 1.25rem;
  color: var(--accent-green);
  margin-right: 0.75rem;
}

.files-preview .file-name {
  font-weight: 500;
  color: var(--text-primary);
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.files-preview .file-size {
  color: var(--text-secondary);
  font-size: 0.8rem;
  margin-right: 8px;
  margin-bottom: 0;
}

.remove-file-button {
  background: none;
  border: none;
  color: var(--danger-color);
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.remove-file-button:hover {
  background-color: rgba(220, 53, 69, 0.1);
}

.remove-file-button i {
  font-size: 1rem;
}

.upload-button {
  width: auto;
  min-width: 120px;
  max-width: 180px;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  gap: 0.5rem;
  background: linear-gradient(135deg, #1f5d38 0%, #2a734a 100%);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 10px rgba(31, 93, 56, 0.25);
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}

.files-preview .upload-button {
  margin-top: 16px;
  width: 100%;
  max-width: 100%;
}

.upload-button:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.upload-button:hover {
  background: linear-gradient(135deg, #2a734a 0%, #378a5b 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(31, 93, 56, 0.3);
}

.upload-button:hover:before {
  opacity: 1;
}

.upload-button:active {
  transform: translateY(1px);
  box-shadow: 0 2px 5px rgba(31, 93, 56, 0.2);
}

.upload-button i {
  font-size: 1.1rem;
}

.upload-button:hover i {
  transform: translateY(-2px);
}

.last-uploaded-file {
  background: white;
  border-radius: 10px;
  margin-top: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  border-left: 4px solid var(--success-color);
  padding-left: 20px;
}

.last-file-header {
  background-color: #f0f9f0;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-bottom: 1px solid #e5f5e5;
}

.last-file-header i {
  color: var(--success-color);
  font-size: 1.25rem;
}

.last-file-header span {
  font-weight: 600;
  color: var(--text-primary);
}

.last-file-content {
  padding: 1rem;
}

.last-file-name {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 1rem;
  margin-bottom: 0.5rem;
  word-break: break-all;
}

.last-file-date {
  color: var(--text-secondary);
  font-size: 0.875rem;
}

.sync-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 2rem 0;
}

.sync-button {
  padding: 0.875rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);
  transition: background-color 0.2s, box-shadow 0.2s;
}

.sync-button:hover {
  background: #2563EB;
  box-shadow: 0 6px 14px rgba(59, 130, 246, 0.4);
}

.sync-button i {
  font-size: 1.2rem;
}

.file-table {
  width: 100%;
  border-collapse: collapse;
}

.file-table th,
.file-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.file-table th {
  background: var(--bg-gradient);
  color: white;
  font-weight: 600;
}

.file-table tr:hover {
  background-color: #f8fafc;
}

.download-button {
  background: none;
  border: none;
  color: var(--primary-color);
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.download-button:hover {
  background: #f0f7ff;
}

.file-search-input {
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  width: 100%;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.filter-buttons-SwitchOut {
  display: flex;
  justify-content: center;
  margin: 1rem 0;
  width: 100%;
}

.p-selectbutton {
  display: flex;
  justify-content: center;
  border-radius: 8px;
  flex-wrap: wrap; /* Permette ai bottoni di andare a capo su schermi piccoli */
}

.p-selectbutton .p-button {
  background-color: white;
  font-weight: bold;
  transition: all 0.2s;
  padding: 10px 20px;
  border-radius: 8px;
  color: #414141;
  margin: 2px; /* Spazio tra i bottoni in wrap */
}

.p-selectbutton .p-button.p-highlight {
  background: var(--accent-green) !important;
  border-color: var(--accent-green);
  color: white;
}

.files-preview::-webkit-scrollbar {
  width: 6px;
}

.files-preview::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.files-preview::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.files-preview::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

@media (max-width: 991px) {
  .card-group {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}

@media (max-width: 767px) {
  .card-group {
    grid-template-columns: 1fr;
  }

  .center-content {
    padding: 1rem;
  }
  
  .files-preview .file-name {
    max-width: 120px;
  }
}
</style>